import React from "react";
import styled, { keyframes } from "styled-components";
import Globais from "../../components/Globais";
import { useSearchParams } from "react-router-dom";
import TabelaPlanosCotas from "../../components/TabelaPlanosCotas";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const FadeInContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  animation: ${fadeIn} 0.7s ease-out;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #0077cc;
  margin-bottom: 1rem;
`;

const Subtitle = styled.h2`
  font-size: 1.4rem;
  color: #222;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  text-align: left;
  max-width: 600px;
  margin: 0 auto 1.5rem;
  padding-left: 1rem;

  li {
    font-size: 1rem;
    color: #444;
    margin-bottom: 0.6rem;
  }
`;

const InfoBox = styled.div`
  background-color: #eef6ff;
  color: #003d73;
  padding: 1.5rem;
  border-radius: 8px;
  font-size: 1.05rem;
  margin: 2rem 0;
  text-align: center;
  font-weight: 500;
`;

const CTAButton = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  display: inline-block;
  transition: background 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;

const Small = styled.p`
  font-size: 0.9rem;
  color: #888;
  margin-top: 1rem;
`;

const FinalLine = styled.p`
  font-size: 1.1rem;
  color: #444;
  margin-top: 2rem;
  font-style: italic;
`;


export default function ViewPagamentoVenda(){

 const [params] = useSearchParams();
  const cotas = Number(params.get("cotas")) || 1;
   const precoBase = 118.8;

  const descontos: Record<1 | 2 | 3 | 4 | 5 | 6, number> = {
    1: 0,
    2: 11.8,
    3: 28.3,
    4: 47.5,
    5: 71.3,
    6: 106.92,
  };
  const links = {
  1: Globais.LINK_PAGAMENTO1,
  2: Globais.LINK_PAGAMENTO2,
  3: Globais.LINK_PAGAMENTO3,
  4: Globais.LINK_PAGAMENTO4,
  5: Globais.LINK_PAGAMENTO5,
  6: Globais.LINK_PAGAMENTO6,


};

  const pagamentoLink = links[cotas as 1 | 2 | 3 | 4 | 5 | 6] || links[1];

  const desconto = descontos[(cotas as 1 | 2 | 3 | 4 | 5 | 6)] || 0;
  const valorFinal = precoBase * cotas - desconto;
  const mensal = valorFinal / 12;
  return (
        <Wrapper>
      <FadeInContent>
        <Title>🎉 Cadastro recebido com sucesso!</Title>

        <Paragraph>
          Recebemos as informações da sua cota.
        </Paragraph>

        <Paragraph>
          👀 Vimos que você marcou a opção de <strong>venda</strong>, e isso é totalmente possível com a gente — com mais visibilidade, suporte e segurança.
        </Paragraph>

        <Subtitle>💡 Como funciona a ativação do seu anúncio de venda:</Subtitle>

        <List>
          <li>📢 Divulgação em nosso site e redes sociais</li>
          <li>📋 Possibilidade de acompanhamento jurídico com escritório parceiro no fechamento da venda</li>
          <li>📞 Suporte por WhatsApp e contato direto com interessados</li>
          <li>💳 Opção de financiamento com financeira parceira — mais chances de fechar negócio!</li>
          <li>📅 Anúncio ativo por 12 meses</li>
        </List>
        <InfoBox>
          Você está ativando {cotas} cota{cotas > 1 ? 's' : ''} com suporte completo.<br />
          Valor total: <strong>R$ {valorFinal.toFixed(2)}</strong><br />
          Equivalente a <strong>R$ {mensal.toFixed(2)}/mês</strong> por 12 meses.
        </InfoBox>
        

       

        <Paragraph>
          Isso garante que só cotas reais estejam ativas e que os compradores recebam anúncios confiáveis.
        </Paragraph>

       <CTAButton
          href={pagamentoLink} 
          target="_blank"
        >
          ✅ Ativar anúncio de {cotas} cota{cotas > 1 ? 's' : ''}
        </CTAButton>

        <Small>
          Ao clicar, você será redirecionado para uma página de pagamento segura.
        </Small>
        

        <FinalLine>
          Você está a um passo de colocar sua cota em destaque e dar um novo destino a ela — com liberdade e visibilidade real.
        </FinalLine>
        <TabelaPlanosCotas/>
      </FadeInContent>
    </Wrapper>
  );
}
 


